import styles from "./index.module.css";
import "./index.css";

import React, {useEffect, useState} from 'react';
import {components} from "react-select";
import {get, set, forOwn, omit} from "lodash";
import {SelectDynamicValueFunction} from 'Core/components/input/SelectInput';
import {getNumber, getObject, getString} from 'Core/helpers/data';
import NumberLabel from 'Core/components/display/NumberLabel';
import {getTranslation, i18nEffect, translate} from 'Core/i18n';
import Label from 'Core/components/display/Label';
import {CUSTOMER_GROUP_STATUS_COLOR_CLASS} from 'Pages/apps/default/customerGroups/const';

/**
 * Select option replacement component of customer group select input that includes the customers count
 * @description Use this as an Option component replacement for the SelectInput (react-select) component. You can pass
 * Label component props through the 'labelProps' prop of the SelectInput component. These props can be an instance of 
 * SelectDynamicValueFunction class if the prop should depend on option data.
 *
 * @param {Object} props - Option props sent by the react-select component to all the options.
 * @return {JSX.Element}
 * @constructor
 */
const CountOptionComponent = props => {
	// Define component's translation path.
	const translationPath = 'CustomerGroupSelectInput';

	// Use 'i18nEffect' function in React 'useEffect' function to update (re-render) component when translation changes.
	const i18nEffectHook = i18nEffect.bind(null, useState(getTranslation())[1]);
	useEffect(() => { i18nEffectHook(); }, [i18nEffectHook]);
	
	const labelProps = get(props, 'selectProps.labelProps', {});

	// If any prop is an instance of SelectDynamicValueFunction class, call the inner func and pass the option data to it 
	// to get the actual value
	let labelComponentProps = {};
	forOwn(labelProps, (value, key) => {
		if (value instanceof SelectDynamicValueFunction) {
			try { set(labelComponentProps, key, value.func(props.data)); }
			catch (e) { omit(labelComponentProps, [key]); }
		}
		else set(labelComponentProps, key, value);
	});
	const customerCount = getNumber(props, 'data.customerCount');
	const status = getString(props, 'data.status');

	return (
		<components.Option {...props}>
			<div className={styles['wrapper']}>
				<Label
					element="div"
					elementProps={{className: `${styles['label']}`}}
					icon="circle"
					iconClassName={`customer-group-status-icon ${CUSTOMER_GROUP_STATUS_COLOR_CLASS[status]}`}
					content={props.label}
				/>
				<NumberLabel 
					{...labelComponentProps} 
					element="div"
					elementProps={{
						...getObject(labelComponentProps, 'elementProps'),
						className: `${getString(labelComponentProps, 'elementProps.className')} ${styles['count']}`
					}}
					prefix={translate('customers_count_prefix', translationPath)}
					number={customerCount}
				/>
			</div>
		</components.Option>
	)
};

export default CountOptionComponent;